import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a55ba24"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TUI-conversation" }
const _hoisted_2 = {
  key: 0,
  class: "network"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-error" }, "!", -1))
const _hoisted_4 = { class: "TUI-conversation-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TUIConversationList = _resolveComponent("TUIConversationList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isNetwork)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("p", null, "️" + _toDisplayString(_ctx.$t('TUIConversation.网络异常，请您检查网络设置')), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("main", _hoisted_4, [
      _createVNode(_component_TUIConversationList, {
        currentID: _ctx.currentConversationID,
        data: _ctx.conversationData,
        onHandleItem: _ctx.handleCurrentConversation,
        isH5: _ctx.env.isH5,
        displayOnlineStatus: _ctx.displayOnlineStatus,
        userStatusList: _ctx.userStatusList
      }, null, 8, ["currentID", "data", "onHandleItem", "isH5", "displayOnlineStatus", "userStatusList"])
    ])
  ]))
}